export default __webpack_public_path__ + "static/media/gal2.82c3441e.jpg";